import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Master.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import { FaEdit } from "react-icons/fa";
import { AddKaryawanEntity, EditKaryawanEntity, KaryawanEntity } from "../../entities/KaryawanEntity";
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { KaryawanService } from "../../services/karyawans";
import { format } from "date-fns";
import FilterUtils from "../../utils/filter-utils";
import { DepartemenService } from "../../services/departemens";
import PopupPilih from "../../components/Popup/PopupPilih";
import { PopUpPilihEntity } from "../../components/Popup/PopupPilihEntity";

export default function MasterKaryawan() {
    // ========================================= GLOBAL CONTEXT =========================================  //
    const context = useContext(AppContext);
    const contextAccessToken = context.contextAccessToken;
    const contextShowAlertFunc = context.contextShowAlertFunc;
    const contextShowLoadingFunc = context.contextShowLoadingFunc;
    const stateShowLoading = context.stateShowLoading
    // ========================================= GLOBAL CONTEXT =========================================  //


    // ========================================= STATE VIEW =========================================  //
    const [tableDataFilter, setTableDataFilter] = useState<{ [key: string]: string }>({});

    const [tableData, setTableData] = useState<KaryawanEntity[]>([]);

    const [selectedKaryawan, setSelectedKaryawan] = useState<EditKaryawanEntity | null>(null);
    const [selectedAddKaryawan, setSelectedAddKaryawan] = useState<AddKaryawanEntity | null>(null);

    const [showPopup, setShowPopup] = useState(false);
    const [showImportPopup, setShowImportPopup] = useState(false);
    const [showImportedPopup, setShowImportedPopup] = useState(false);
    const [tableImportedPopup, setTableImportedPopup] = useState<KaryawanEntity[]>([]);

    const [showPopupPilih, setShowPopupPilih] = useState(false);
    const [popUpPilihEntity, setPopUpPilihEntity] = useState<PopUpPilihEntity>();

    // ========================================= STATE VIEW =========================================  //

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    const handleSelectDepartemen = async () => {
        contextShowLoadingFunc(true);
        setShowPopup(false)
        try {
            const resp = await DepartemenService.GetAllDepartemen();
            setPopUpPilihEntity(new PopUpPilihEntity({
                popupTitle: 'Pilih Grup',
                tableContent: resp,
                onClick: (row) => {
                    selectedKaryawan != null ?
                        setSelectedKaryawan((prevState: EditKaryawanEntity | null) => {
                            if (prevState == null) {
                                return null;
                            } else {
                                return new EditKaryawanEntity({
                                    ...prevState,
                                    id_departemen: row.id,
                                    departemen: row.departemen
                                })
                            }
                        })
                        :
                        setSelectedAddKaryawan((prevState: AddKaryawanEntity | null) => {
                            return new AddKaryawanEntity({
                                ...prevState,
                                id_departemen: row.id,
                                departemen: row.departemen
                            })
                        })
                        ; setShowPopup(true)
                },
                onClose: () => { setShowPopupPilih(false); setShowPopup(true) }
            }))
            setShowPopupPilih(true);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleAddNew = () => {
        setSelectedAddKaryawan(null);
        setSelectedKaryawan(null);
        setShowPopup(true);
    }

    const handlePopupDetail = (row: KaryawanEntity) => {
        setSelectedKaryawan(row);
        setShowPopup(true)
    }

    const handleSaveAddKaryawan = async () => {
        contextShowLoadingFunc(true);
        try {
            if (selectedAddKaryawan == null || selectedAddKaryawan.ncode == null ||
                selectedAddKaryawan.nama == null || selectedAddKaryawan.id_card == null ||
                selectedAddKaryawan.id_departemen == null || selectedAddKaryawan.departemen == null) {
                throw new Error("invalid data")
            }

            const resp = await KaryawanService.AddKaryawan({
                ncode: selectedAddKaryawan.ncode, id_card: selectedAddKaryawan.id_card,
                nama: selectedAddKaryawan.nama, id_departemen: selectedAddKaryawan.id_departemen,
            });
            await generateData();
            contextShowLoadingFunc(false);
            setSelectedKaryawan(null);
            setSelectedAddKaryawan(null);
            setShowPopup(false);
            contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleSaveUpdateKaryawan = async () => {
        contextShowLoadingFunc(true);
        try {
            if (selectedKaryawan == null) { throw new Error("invalid selected karyawan") }
            const resp = await KaryawanService.UpdateKaryawan(selectedKaryawan, {
                ncode: selectedKaryawan.ncode, id_card: selectedKaryawan.id_card,
                nama: selectedKaryawan.nama, id_departemen: selectedKaryawan.id_departemen,
            });
            await generateData();
            contextShowLoadingFunc(false);
            setSelectedKaryawan(null);
            setShowPopup(false);
            contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleDeleteKaryawan = async () => {
        return contextShowAlertFunc(new AlertEntity({
            message: `Apakah anda yakin ingin menghapus ${selectedKaryawan?.nama} ?`,
            onOk: async () => {
                contextShowLoadingFunc(true);
                try {
                    if (selectedKaryawan == null) { throw new Error("invalid selected karyawan") }
                    const resp = await KaryawanService.DeleteKaryawan(selectedKaryawan);
                    await generateData();
                    contextShowLoadingFunc(false);
                    setSelectedKaryawan(null);
                    setShowPopup(false);
                    contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
                } catch (error: any) {
                    contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
                    contextShowLoadingFunc(false);
                }
            },
            withCancel: true,
            withOk: true,
            level: 2
        }))
    }

    const handleGenerateExcel = async () => {
        if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
        const column = ["ncode", "id_card", "nama", "departemen"];
        let values: { [key: string]: string }[] = [];
        for (let i = 0; i < tableData.length; i++) {
            values.push({
                ncode: tableData[i].ncode.toString() ?? null,
                id_card: tableData[i].id_card.toString() ?? null,
                nama: tableData[i].nama,
                departemen: tableData[i].departemen ?? '',
            })
        }
        ExcelUtils.export(`Karyawan List on ${format(new Date(), "yyyy-MM-dd")}`, column, values);
    }

    const handleSelectExcelFile = async (event: any) => {
        try {
            const file = event.target.files[0];
            let ext = file.name.split('.').pop();
            if (ext.toLowerCase() != 'xlsx') {
                return contextShowAlertFunc(new AlertEntity({ message: `File is not supported!`, level: 3 }));
            }
            const result = await ExcelUtils.import(file);
            const data: KaryawanEntity[] = []
            for (let i = 0; i < result.length; i++) {
                data.push(new KaryawanEntity({
                    id: 0,
                    ncode: result[i].ncode.toString(),
                    id_card: result[i].id_card.toString(),
                    nama: result[i].nama.toString(),
                    departemen: result[i].departemen.toString(),
                }))
            }
            setShowImportPopup(false);
            setTableImportedPopup(data);
            setShowImportedPopup(true);
        } catch (error: any) {
            return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
        }
    }

    const importExcel = async () => {
        contextShowLoadingFunc(true);
        try {
            let resp = await KaryawanService.ImportKaryawan(tableImportedPopup);
            await generateData();
            contextShowLoadingFunc(false);
            setShowImportedPopup(false);
            return contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowLoadingFunc(false);
            return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
        }
    }

    const generateData = async () => {
        contextShowLoadingFunc(true);
        try {
            const resp = await KaryawanService.GetAllKaryawan();
            setTableData(resp);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    };

    useEffect(() => {
        generateData();
    }, [contextAccessToken]);

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    return (
        <>
            <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
                <Card
                    detailTitle="Master Karyawan"
                    detailColor="var(--secondary-color)"
                    backgroundImage={backgroundCard}
                    stateShow={true}
                    detailCard={
                        <>
                            <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                                <div>
                                    <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                                    <button className="cardButton" onClick={() => handleAddNew()} >
                                        Add New
                                    </button>
                                </div>
                                <div>
                                    <button className="cardButton" onClick={() => handleGenerateExcel()} >
                                        Generate Excel
                                    </button>
                                </div>
                                <div>
                                    <button className="cardButton" onClick={() => setShowImportPopup(true)}>
                                        Import Excel
                                    </button>
                                </div>
                            </div>
                            <div className={css.rowGrid} style={{ alignItems: 'end', marginTop: "1vh" }}>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>ncode :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, ncode: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>id_card :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, id_card: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>nama :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, nama: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>departemen :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, departemen: event.target.value }));
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    }
                />
                <div
                    style={{
                        height: "65vh",
                        overflow: "auto"
                    }}>
                    <table className="tableclickcell">
                        {tableData.length > 0 ?
                            <>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>NCode</th>
                                        <th>IDCard</th>
                                        <th>Nama</th>
                                        <th>Departemen</th>
                                        <th>Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.filter((row) => {
                                        return FilterUtils.FilterTable(row, tableDataFilter)
                                    })
                                        .map((row, idx) => {
                                            return <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{row.ncode}</td>
                                                <td>{row.id_card}</td>
                                                <td>{row.nama}</td>
                                                <td>{row.departemen}</td>
                                                <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><FaEdit /> Edit</td>
                                            </tr>
                                        })}
                                </tbody>
                            </>
                            :
                            <>
                                <thead><tr><th>no data available yet!</th></tr></thead>
                            </>
                        }
                    </table>
                </div>

                {/* Popup Detail */}
                <Popup
                    setShowPopup={setShowPopup}
                    showPopup={showPopup}
                    popupTitle={selectedKaryawan == null ? "Add New" : `Edit ${selectedKaryawan?.nama}`}
                    popupContent={
                        selectedKaryawan == null ?
                            <>
                                <div className={css.form}>
                                    <div className={css.containerleftright}>
                                        <div className={css.leftposition}>
                                            <div className={css.label}> NCode <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedAddKaryawan?.ncode ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddKaryawan((prevState: AddKaryawanEntity | null) => {
                                                        return new AddKaryawanEntity({
                                                            ...prevState,
                                                            ncode: (event.target.value)
                                                        })
                                                    });
                                                }}
                                            />
                                            <div className={css.label}> IDCard <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedAddKaryawan?.id_card ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddKaryawan((prevState: AddKaryawanEntity | null) => {
                                                        return new AddKaryawanEntity({
                                                            ...prevState,
                                                            id_card: (event.target.value)
                                                        })
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className={css.rightposition}>
                                            <div className={css.label}> Nama <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedAddKaryawan?.nama ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddKaryawan((prevState: AddKaryawanEntity | null) => {
                                                        return new AddKaryawanEntity({
                                                            ...prevState,
                                                            nama: event.target.value
                                                        })
                                                    });
                                                }}
                                            />
                                            <div className={css.label}> Departemen <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" readOnly
                                                value={selectedAddKaryawan?.departemen ?? ""}
                                                onClick={handleSelectDepartemen}
                                            />
                                        </div>
                                    </div>
                                    <div className={css.buttons2}>
                                        <div className={css.left}>
                                            <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                                                Close
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="primaryButton"
                                                onClick={() => { handleSaveAddKaryawan() }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <>
                                <div className={css.form}>
                                    <div className={css.containerleftright}>
                                        <div className={css.leftposition}>
                                            <div className={css.label}> NCode <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedKaryawan?.ncode ?? ""}
                                                onChange={(event) => {
                                                    setSelectedKaryawan((prevState: EditKaryawanEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new EditKaryawanEntity({
                                                                ...prevState,
                                                                ncode: (event.target.value)
                                                            })
                                                        }
                                                    });
                                                }}
                                            />
                                            <div className={css.label}> IDCard <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedKaryawan?.id_card ?? ""}
                                                onChange={(event) => {
                                                    setSelectedKaryawan((prevState: EditKaryawanEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new EditKaryawanEntity({
                                                                ...prevState,
                                                                id_card: (event.target.value)
                                                            })
                                                        }
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className={css.rightposition}>
                                            <div className={css.label}> Nama <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedKaryawan?.nama ?? ""}
                                                onChange={(event) => {
                                                    setSelectedKaryawan((prevState: EditKaryawanEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new EditKaryawanEntity({
                                                                ...prevState,
                                                                nama: event.target.value
                                                            })
                                                        }
                                                    });
                                                }}
                                            />
                                            <div className={css.label}> Departemen <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" readOnly
                                                value={selectedKaryawan?.departemen ?? ""}
                                                onClick={handleSelectDepartemen}
                                            />
                                        </div>
                                    </div>
                                    <div className={css.buttons2}>
                                        <div className={css.left}>
                                            <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                                                Close
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="secondaryButton" onClick={() => handleDeleteKaryawan()}>
                                                Delete
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="primaryButton"
                                                onClick={() => { handleSaveUpdateKaryawan() }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                />

                {/* Popup Import */}
                <Popup
                    setShowPopup={setShowImportPopup}
                    showPopup={showImportPopup}
                    popupTitle={"Import File"}
                    popupContent={
                        <>
                            <div style={{ maxWidth: '1200px' }}>
                                <label>File Name:</label>
                                <input type="file" onChange={(event) => handleSelectExcelFile(event)} />
                                <br />
                                <br />
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        columnGap: "2vw",
                                    }}
                                >
                                    <div>Notes : Pakai Template Seperti hasil dari Generate Excel dan Pastikan Nama Departemen Sama dengan Master Departemen <span style={{ color: "red" }}>*</span></div>
                                </div>
                            </div>
                        </>
                    }
                />
                {/* Popup Imported */}
                <Popup
                    setShowPopup={setShowImportedPopup}
                    showPopup={showImportedPopup}
                    popupTitle={"Imported"}
                    popupContent={
                        <>
                            <div style={{
                                maxHeight: "70vh",
                                overflow: "auto"
                            }}>
                                <table className="tablepopup">
                                    <thead>
                                        <tr key={`tableImportedPopupHeader`}>
                                            {tableImportedPopup.length > 0 && Object.keys(tableImportedPopup[0]).map((key) => {
                                                return <td key={`tableImportedPopupHeader${key}`}>
                                                    {(key)}
                                                </td>
                                            })}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {tableImportedPopup.length > 0 && tableImportedPopup.map((data: any, index) => {
                                            return <tr key={`tableImportedPopup-${index}`}>
                                                {Object.keys(data).map((key) => {
                                                    return <td key={`tableImportedPopup${key}-${index}`}>
                                                        {(data[key])}
                                                    </td>
                                                })}
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "end" }}>
                                <button className="primaryButton" onClick={() => importExcel()}>
                                    Save
                                </button>
                            </div>
                        </>
                    }
                />



                {popUpPilihEntity != null
                    ? <PopupPilih
                        showPopup={showPopupPilih}
                        setShowPopup={setShowPopupPilih}
                        popUpPilihEntity={popUpPilihEntity}
                    />
                    : <></>}
            </div>
        </>
    );
}
